import set from "@rill/set";
import rill from "rill";

import getMasterFoodLibrary from "./master-food-library.controller.js";

const MasterFoodLibrary = (app) => {
  app.at(
    "/master-food-library/*",
    rill()
      .use(set("heading", ["Coaching", "MasterFoodLibrary"]))
      .setup((app) => {
        app.get("/", getMasterFoodLibrary);
      })
  );
};

export default MasterFoodLibrary;
